class DrawerMenu extends HTMLElement {
  constructor() {
    'use strict';
    super();

    this.el = this;
    this.mainLevel = this.el.querySelector('.drawer-menu__contents');
    this.init();
  }

  init() {
    // These toggle submenu panel
    this.firstLevelItemsWithChildren = this.el.querySelectorAll('.drawer-menu__item__input');
    this.firstLevelItemsWithChildren.forEach((input) => {
      input.addEventListener('change', this.toggleMenuItem.bind(this));
    });

    // These handle closing of navigation
    this.closeButtons = this.el.querySelectorAll('[data-close]');
    this.closeButtons.forEach((btn) => {
      btn.addEventListener('click', this.closeAllItems.bind(this));
    });

    this.overlay = this.el.querySelector('[data-overlay]');
    this.overlay.addEventListener('click', this.closeAllItems.bind(this));

    // These handle going back to previous panel
    this.secondLevelBackButtons = this.el.querySelectorAll('[data-drawer-submenu-close]');
    this.secondLevelBackButtons.forEach((button) => {
      button.addEventListener('click', this.toggleSubPanel.bind(this));
    });

    // Handle opening of specific subitem from anywhere in the theme
    this.subitemOpeners = document.querySelectorAll('[data-drawer-submenu-open]');
    this.subitemOpeners.forEach((button) => {
      button.addEventListener('click', this.toggleMenuItemFromTheme.bind(this));
    });
  }

  closeAllItems(event, skipEl) {
    const checkboxes = this.mainLevel.querySelectorAll('input:checked');
    checkboxes.forEach((checkbox) => {
      if (skipEl && checkbox === skipEl) {
        return;
      }
      checkbox.checked = false;
      const accordion = checkbox.closest('[data-accordion-item]');
      if (accordion) {
        accordion.classList.remove('is-open');
        if (screen.width <= 820) {
          const parent = accordion.closest('.drawer-menu__contents');
          parent.classList.remove('pull-left');
        }
      }
    });

    if (!skipEl) {
      this.mainLevel.classList.remove('has-open-submenu');
    }
  }

  toggleMenuItem(scope) {
    const input = scope.currentTarget || scope;
    if (!input) return;

    this.closeAllItems(scope, input);

    const accordion = input.closest('[data-accordion-item]');
    if (!accordion) {
      return;
    }
    if (screen.width <= 820) {
      const parent = accordion.closest('.drawer-menu__contents');
      parent.classList.toggle('pull-left');
    }
    
    accordion.classList.toggle('is-open');
    if (accordion.classList.contains('is-open')) {
      this.mainLevel.classList.add('has-open-submenu');
    } else {
      this.mainLevel.classList.remove('has-open-submenu');
    }
  }

  toggleMenuItemFromTheme(scope) {
    let target = false;
    const button = scope.currentTarget || scope;
    const url = button.getAttribute('data-drawer-submenu-open');

    for (const input of this.firstLevelItemsWithChildren) {
      if (input.getAttribute('data-href') === url) {
        target = input;
        break;
      }
    }

    if (!target) return;

    Woolman.ModalsAndDrawers.showModalOrDrawer(this.el.getAttribute('id'));

    const animationFinished = () => {
      this.el.removeEventListener('transitionend', animationFinished);

      const evt = new Event('change');
      target.checked = true;
      target.dispatchEvent(evt);
    };
    this.el.addEventListener('transitionend', animationFinished);
  }

  toggleSubPanel(event) {
    this.closeAllItems();

    const button = event.currentTarget;
    const targetSelector = button.getAttribute('data-drawer-submenu-close');
    if (!targetSelector) {
      return;
    }

    const input = document.getElementById(targetSelector);
    if (!input) {
      return;
    }

    input.focus();
  }
}

if (customElements.get('drawer-menu') === undefined) {
  customElements.define('drawer-menu', DrawerMenu);
}

// CUSTOM CODE BY SNAG ECOM TEAM - Handles subsubmenu items in accordions
function setupNestedAccordions() {
  document.querySelectorAll('.drawer-submenu__item[aria-label*="by"]:not(.accordion-processed)').forEach(trigger => {
    trigger.classList.add('accordion-processed');
    
    const accordionWrapper = document.createElement('div');
    accordionWrapper.className = 'submenu-accordion';
    const parent = trigger.parentNode;
    parent.insertBefore(accordionWrapper, trigger);
    accordionWrapper.appendChild(trigger);
    
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-expanded', 'false');
    
    trigger.innerHTML += '<span class="submenu-chevron"><svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg></span>';
    
    const contentWrapper = document.createElement('div');
    contentWrapper.className = 'submenu-accordion-content';
    accordionWrapper.appendChild(contentWrapper);
    
    let nextElement = accordionWrapper.nextElementSibling;
    while (nextElement && nextElement.classList.contains('drawer-subsubmenu__item')) {
      const currentElement = nextElement;
      nextElement = nextElement.nextElementSibling;
      currentElement.removeAttribute('style');
      contentWrapper.appendChild(currentElement);
    }
    
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      document.querySelectorAll('.drawer-submenu__item[aria-expanded="true"]').forEach(item => {
        if (item !== this) {
          item.setAttribute('aria-expanded', 'false');
          item.closest('.submenu-accordion').classList.remove('is-open');
        }
      });
      
      this.setAttribute('aria-expanded', !isExpanded);
      this.closest('.submenu-accordion').classList.toggle('is-open', !isExpanded);
    });
  });
}

function initAccordions() {
  setupNestedAccordions();
  setTimeout(setupNestedAccordions, 300);
}

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  initAccordions();
} else {
  document.addEventListener('DOMContentLoaded', initAccordions);
}

document.addEventListener('drawer:opened', function(e) {
  if (e.target.id === 'drawer-menu') {
    setTimeout(setupNestedAccordions, 100);
  }
});
